module.exports = __webpack_public_path__ + "7ab4757663096a72c8414df40d4216ff.png";